import CommunicationProgramKeyUserDetailsContainer from './CommunicationProgramKeyUserDetailsContainer.js';

export default CommunicationProgramKeyUserDetailsContainer;